import {createPopper} from "@popperjs/core";
import {isPermission} from "@/utils/utils";

export const colorGeoCard = {
    methods: {
        getColorForCard(field) {
            const green = ['Depositor', 'Potential High', 'Potential Low']
            const grey = ['Initial call', 'Voicemail', 'New', 'Waiting', 'Callback', 'Reassign', 'Duplicate', 'No answer']
            const yellow = ['Not found']

            if (green.includes(field)) return 'green'
            if (grey.includes(field)) return 'grey'
            if (yellow.includes(field)) return '#ff8200'
            return 'red'
        }
    }
}

export const sorting = {
    methods: {
        sortByAlphabet(array, nameProperty) {
            return array.sort((a, b) => {
                const firstElement = typeof a[nameProperty] === 'string' ? a[nameProperty].toLowerCase() : a[nameProperty],
                    secondElement = typeof b[nameProperty] === 'string' ? b[nameProperty].toLowerCase() :  b[nameProperty]
                return firstElement < secondElement ? -1 : firstElement > secondElement ? 1 : 0
            })
        },
    }
}

export const colorForCardStatuses = {
    data() {
        return {
            settingsStatuses: {
                allStatuses: ['new', 'active', 'inactive', 'closed']
            }
        }
    },
    methods: {
        getColorStatus(statusName) {
            const findSettings = this.settingsStatuses.allStatuses.find(status => status === String(statusName).toLowerCase())
            return `card-status__${findSettings ? findSettings : 'unknow'}`
        }
    }
}

export const checkPermission = {
    methods: {
        isPermission(name) {
            return isPermission(name)
        }
    }
}

export const systemSettings = {
    methods: {
        systemSetting(name) {
            return getSystemSetting(name)
        }
    }
}

export const exclude = {
    methods: {
        excludeKey(listKey, sourceObject) {
            const newObject = {}
            for (const key in sourceObject) {
                if (!listKey.some(item => item === key)) {
                    newObject[key] = sourceObject[key]
                }
            }
            return newObject
        }
    }
}

export const flag = {
    methods: {
        getFlag(iso2) {
            const changeIso = {
                EN: 'GB',
                UK: 'UA',
                JA: 'JP',
                EL: 'GR',
                CS: 'CZ',
                KA: 'GE',
                ZH: 'CN',
            }

            return changeIso[iso2] ? changeIso[iso2] : iso2
        },
    }
}

export const fixHindusPagination = {
    methods: {
        getPages(ref) {
            return () => {
                const max = 9
                if (ref) {
                    if (ref.total <= max) {
                        ref.pages = ref.setPages(1, ref.total)
                    }
                    const even = max % 2 === 0 ? 1 : 0
                    if (ref.total < 6) {
                        ref.prevRange = Math.floor(max / (max / 2))
                    } else {
                        ref.prevRange = Math.floor(max / 2)
                    }
                    ref.nextRange = ref.total - ref.prevRange + 1 + even

                    if (ref.current >= ref.prevRange && ref.current <= ref.nextRange) {
                        const start = ref.current - ref.prevRange + 2
                        const end = ref.current + ref.prevRange - 2 - even
                        if (ref.total > max) {
                            ref.pages = [1, '...', ...ref.setPages(start, end), '...', ref.total]
                        }
                    } else if (ref.total < max) {
                        ref.pages = [
                            ...ref.setPages(1, ref.total)
                        ]
                    } else {
                        ref.pages = [
                            ...ref.setPages(1, ref.prevRange),
                            '...',
                            ...ref.setPages(ref.nextRange, ref.total)
                        ]
                    }
                }
            }
        }
    }
}

export const getDate = {
    filters: {
        getDate(value) {
            const timeZone = 'Europe/Kiev'
            if (/T/.test(value)) {
                return new Date(value).toLocaleDateString('ru', {timeZone})
            } else {
                const date = value.replace(/ /g, 'T')
                return new Date(date).toLocaleDateString('ru', {timeZone})
            }

        },
        getTime(value) {
            const timeZone = 'Europe/Kiev'
            if (/T/.test(value)) {
                return new Date(value).toLocaleTimeString('ru', {timeZone})
            } else {
                const date = value.replace(/ /g, 'T')
                return new Date(date).toLocaleTimeString('ru', {timeZone})
            }
        }
    },
}

export const dateParse = {
    methods: {
        dateParse(date) {
            return new Date(date)
                .toLocaleString('ru')
                .split(',')[0]
                .split('.')
                .reverse()
                .join('-')
        }
    }
}

export const dataSort = {
    methods: {
        sort(a, b) {
            const nameList = ['label', 'name', 'text']
            let key

            nameList.map(name => {
                if (a[name] && b[name]) key = name
            })

            if (a[key].toLowerCase() < b[key].toLowerCase()) {
                return -1
            }
        }
    }
}

export const vSelectPosition = {
    data() {
        return {
            placement: 'bottom',
        }
    },

    methods: {
        withPopper(dropdownList, component, {width, top, left}) {
            dropdownList.style.top = top
            dropdownList.style.left = left
            dropdownList.style.width = width

            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: this.placement,
                modifiers: [
                    {
                        name: 'offset',
                        options: {offset: [0, -1]}
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({state}) {
                            component.$el.classList.toggle('drop-up', state.placement === 'top')
                        }
                    },
                ],
            })

            return () => popper.destroy()
        },
    }
}

export const object = {
    methods: {
        isObject(value) {
            return typeof value === "object" && value !== null && !Array.isArray(value);
        }
    }
}

export const utils = {
    data() {
        return {
            delimiters: [',', ';', '\t']
        }
    },

    methods: {
        getHeader(csv) {
            return csv.split('\n')[0].trim()
        },

        bytesToMegabytes(bytes) {
            const kilobyte = 1024;
            const megabyte = kilobyte * 1024;

            if (bytes < kilobyte) {
                return bytes + " bytes"
            } else if (bytes < megabyte) {
                const kilobytes = (bytes / kilobyte).toFixed(2)
                return kilobytes + " KB"
            } else {
                const megabytes = (bytes / megabyte).toFixed(2)
                return megabytes + " MB"
            }
        },

        detectCSVDelimiter(csv) {
            const sampleLine = this.getHeader(csv)

            return this.delimiters.find(delimiter => sampleLine.includes(delimiter)) || ','
        },

        parseCSVToArray(csv) {
            const delimiter = this.detectCSVDelimiter(csv)
            const [headers, ...lines] = csv.split('\n')

            return lines.filter(item => item).map(line => Object.fromEntries(
                headers.split(delimiter).map((header, i) => [header, (line.split(delimiter)[i] || '').trim()])
            ))
        },

        isNumber(str) {
            const num = Number(str);
            return !isNaN(num) && isFinite(num);
        },

        createNameById(data, order = true, a = 'name', b = 'id') {
            const list = data.map(item => {
                item[a] = item[a] || (item[b] || '').toString()
                return item
            })

            if (order) {
                list.sort((x, y) => {
                    const valX = !this.isNumber(x[a]) ? x[a].toLowerCase() : +x[a]
                    const valY = !this.isNumber(y[a]) ? y[a].toLowerCase() : +y[a]

                    return valX > valY ? 1 : valX < valY ? -1 : 0
                })
            }

            return list
        }
    }
}

export const notifications = {
    methods: {
        notifications(title, text, color = 'primary', options) {
            if (!options.time) options.time = 3000
            if (!options['icon-pack']) options['icon-pack'] = 'feather'

            this.$ns.notify({title, text, color, ...options})
        },

        syncServer(responses, time = 3000) {
            const parseErrors = errors => {
                return Object.entries(errors).reduce((res, [key, val]) => {
                    res += `${key}:</br>${val.map(item => `<em>${item}</em></br>`)}`
                    res += '</br>'
                    return res
                }, '')
            }

            for (const response of responses) {
                const code = response.code < 400

                let title = `Server: <em>${response.server}</em> </br> Status: <em>${code ? 'Success' : 'Error'}</em>`
                let message

                if (response.code >= 500) {
                    message = 'Server not responding'
                } else {
                    message = `${code ? 'Success' : parseErrors(response.response.result.errors)}`
                }

                this.notifications(
                    title,
                    message,
                    code ? 'success' : 'danger',
                    {
                        time: time,
                        ...this.$iconData(
                            code ? 'icon-check' : 'icon-error',
                            code ? 'fi-rr-check' : 'fi-rr-exclamation'
                        )
                    }
                )
            }
        }
    }
}
